import { take, call, put } from 'redux-saga/effects';
import * as types from '../../lib/actionTypes.es6';
import {
  getLookupListTypes,
  getLookupList,
  addLookupListItem,
  updateLookupListItem,
  deleteLookupListItem,
} from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

export function* getLookupListTypesRequestWatcher() {
  while (true) {
    try {
      yield take(types.GET_LOOKUP_LIST_TYPES_REQUEST);
      var response = yield call(getLookupListTypes);
      yield put(actions.getLookupListTypesSuccess(response.data));
    } catch (e) {
      var errorPayload = { message: 'An error occurred fetching list types' };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.getLookupListTypesFailure(errorPayload));
      GAloggerException(e);
    }
  }
}

export function* getLookupListRequestWatcher() {
  while (true) {
    try {
      var action = yield take(types.GET_LOOKUP_LIST_REQUEST);
      var listType = action.payload;
      var response = yield call(getLookupList, listType);
      yield put(actions.getLookupListSuccess(listType, response.data));
    } catch (e) {
      var errorPayload = { message: 'An error occurred fetching the list' };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.getLookupListFailure(listType, errorPayload));
      GAloggerException(e);
    }
  }
}

export function* addLookupListItemRequestWatcher() {
  while (true) {
    try {
      var action = yield take(types.ADD_LOOKUP_LIST_ITEM_REQUEST);
      var listType = action.payload.listType;
      var item = action.payload.item;
      var response = yield call(addLookupListItem, listType, item);
      yield put(actions.addLookupListItemSuccess(listType, response.data));
    } catch (e) {
      var errorPayload = { message: 'An error occurred adding the item' };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.addLookupListItemFailure(listType, errorPayload));
      GAloggerException(e);
    }
  }
}

export function* updateLookupListItemRequestWatcher() {
  while (true) {
    try {
      var action = yield take(types.UPDATE_LOOKUP_LIST_ITEM_REQUEST);
      var listType = action.payload.listType;
      var itemValue = action.payload.itemValue;
      var patch = action.payload.patch;
      var response = yield call(updateLookupListItem, listType, itemValue, patch);
      yield put(actions.updateLookupListItemSuccess(listType, response.data));
    } catch (e) {
      var errorPayload = { message: 'An error occurred updating the item' };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.updateLookupListItemFailure(listType, errorPayload));
      GAloggerException(e);
    }
  }
}

export function* deleteLookupListItemRequestWatcher() {
  while (true) {
    try {
      var action = yield take(types.DELETE_LOOKUP_LIST_ITEM_REQUEST);
      var listType = action.payload.listType;
      var itemValue = action.payload.itemValue;
      var response = yield call(deleteLookupListItem, listType, itemValue);
      yield put(actions.deleteLookupListItemSuccess(listType, response.data));
    } catch (e) {
      var errorPayload = { message: 'An error occurred deleting the item' };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.deleteLookupListItemFailure(listType, errorPayload));
      GAloggerException(e);
    }
  }
}
